<ion-content>
  <table class="w-100 h-100">
    <tr>
      <td class="w-100">
        <div class="w-100 h-100" style="position: relative">
          <div
            style="
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              overflow: auto;
            "
          >
            <ion-grid class="p-0">
              <ion-row>
                <ion-col class="pb-0">
                  <ion-card class="m-0">
                    <ion-grid class="p-0">
                      <ion-row>
                        <ion-col>
                          <ion-item lines="none">
                            <ion-label class="m-0">
                              <p>сума замовлення</p>
                              <h1 style="font-size: 28px">
                                {{ orderAmount }}
                              </h1>
                            </ion-label>
                          </ion-item>
                        </ion-col>

                        <ion-col *ngIf="chipsTotal > 0">
                          <ion-item lines="none">
                            <ion-label class="m-0">
                              <p>оплата балами</p>
                              <h1 style="font-size: 28px">
                                {{ chipsTotal }}
                              </h1>
                              <p>отримати від гостя</p>
                            </ion-label>
                          </ion-item>
                        </ion-col>

                        <ion-col *ngIf="hasBonuses">
                          <ion-item
                            class="pay-input"
                            [class.focused]="focusedInput == 'cashbeck'"
                            (click)="focusCashbeck('cashbeck')"
                            lines="none"
                          >
                            <ion-label class="m-0">
                              <p>оплата кешбеком</p>
                              <h1 style="font-size: 28px">
                                <ion-text [color]="cashbackColor">
                                  {{ payBonusesAmount }}
                                </ion-text>
                              </h1>
                              <p>
                                <ion-text [color]="cashbackColor">
                                  на рахунку
                                  {{ customerBonuses.toFixed(2) }}
                                </ion-text>
                              </p>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col *ngIf="discountAmount">
                          <ion-item
                            lines="none"
                            color="success"
                            style="border-radius: 6px"
                          >
                            <ion-label class="m-0">
                              <p>{{ discountSubTitle }}</p>
                              <h1 style="font-size: 28px">
                                {{ discountAmount }}
                              </h1>
                              <p>
                                <span>знижка: </span>
                                <span> {{ discountCond }} </span>
                                <span>&nbsp;&nbsp;від&nbsp;&nbsp;</span>
                                <span>{{ sourceSum }}</span>
                              </p>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col *ngIf="paidAmount">
                          <ion-item
                            lines="none"
                            color="success"
                            style="border: 2px solid green; border-radius: 6px"
                          >
                            <ion-label class="m-0">
                              <p>Сплачено</p>
                              <h1 style="font-size: 28px">
                                {{ paidAmount }}
                              </h1>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col *ngIf="!hasPartialPayment">
                          <ion-item
                            lines="none"
                            style="border: 2px solid green; border-radius: 6px"
                          >
                            <ion-label class="m-0">
                              <p>до сплати</p>
                              <h1 style="font-size: 28px">
                                {{ totalAmount }}
                              </h1>
                              <!-- <p *ngIf="order && order.rndSum">
                                заокруглення {{ order.rndSum }}
                              </p> -->
                            </ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col
                          *ngIf="hasPartialPayment"
                          (click)="focusCashbeck('paymentAmount')"
                        >
                          <ion-item
                            lines="none"
                            class="pay-input"
                            [color]="amountColor"
                            [class.focused]="focusedInput == 'paymentAmount'"
                          >
                            <ion-label class="m-0">
                              <p>
                                <ion-text>Платіж</ion-text>
                              </p>
                              <h1 style="font-size: 28px">
                                <ion-text> {{ paymentAmount }}</ion-text>
                              </h1>
                              <p>
                                <span>повна оплата: </span>
                                <span> {{ totalAmount }} </span>
                              </p>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col *ngIf="paymentType == 'card'">
                          <ion-item
                            lines="none"
                            style="border: 2px solid grey; border-radius: 6px"
                          >
                            <ion-label class="m-0">
                              <p>
                                <ion-text>оплата картою</ion-text>
                              </p>
                              <h1 style="font-size: 28px">
                                {{ paymentAmount }}
                              </h1>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col
                          *ngIf="paymentType == 'cash'"
                          (click)="focusCashbeck('cashInput')"
                        >
                          <ion-item
                            lines="none"
                            class="pay-input"
                            [class.focused]="focusedInput == 'cashInput'"
                            [color]="providedColor"
                          >
                            <ion-label class="m-0">
                              <p>
                                <ion-text>Отримано готівки</ion-text>
                              </p>
                              <h1 style="font-size: 28px">
                                <ion-text> {{ providedAmount }}</ion-text>
                              </h1>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col *ngIf="paymentType == 'cash'">
                          <ion-item
                            lines="none"
                            class="pay-input"
                            style="border: 2px solid blue"
                          >
                            <ion-label class="m-0">
                              <p>
                                <ion-text> Решта </ion-text>
                              </p>
                              <h1 style="font-size: 28px">
                                <ion-text> {{ remainsAmount }}</ion-text>
                              </h1>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col size="4" *ngIf="futureBonusesAmount">
                          <ion-item
                            lines="none"
                            color="success"
                            style="border-radius: 6px"
                          >
                            <ion-label class="m-0">
                              <p>кешбек: {{ discountSubTitle }}</p>
                              <h1 style="font-size: 28px">
                                {{ futureBonusesAmount }}
                              </h1>
                              <span>{{ discountCond }}</span>
                              <span>&nbsp;&nbsp;від&nbsp;&nbsp;</span>
                              <span>{{ sourceSum }}</span>
                            </ion-label>
                          </ion-item>
                        </ion-col>

                        <ion-col size="4" *ngIf="chipsTotal < 0">
                          <ion-item
                            lines="none"
                            color="success"
                            style="border-radius: 6px"
                          >
                            <ion-label class="m-0">
                              <p>бали за покупку</p>
                              <h1 style="font-size: 28px">
                                {{ chipsTotal * -1 }}
                              </h1>
                              <p>видати гостю</p>
                            </ion-label>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="!paymentMethod">
                        <ion-col size="12" size-md="6">
                          <ion-button
                            (click)="selectPaymentType('cash')"
                            size="large"
                            [fill]="getFill('cash')"
                            expand="block"
                            class="m-0 payment-btn"
                          >
                            <ion-icon
                              style="font-size: 28px"
                              class="mr-3"
                              name="cash-outline"
                            ></ion-icon>
                            <ion-label style="font-size: 22px"
                              ><span i18n="@@finList.payCash">Готівка</span></ion-label
                            >
                          </ion-button></ion-col
                        >
                        <ion-col size="12" size-md="6">
                          <ion-button
                            (click)="selectPaymentType('card')"
                            size="large"
                            [fill]="getFill('card')"
                            expand="block"
                            class="m-0 payment-btn"
                          >
                            <ion-icon
                              style="font-size: 28px"
                              class="mr-3"
                              name="card-outline"
                            ></ion-icon>
                            <ion-label style="font-size: 22px"
                              ><span i18n="@@finList.payCard">Картка</span></ion-label
                            >
                          </ion-button></ion-col
                        >
                      </ion-row>
                    </ion-grid>
                  </ion-card>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="p-0">
                  <ion-grid class="w-100">
                    <ion-row>
                      <ion-col class="px-0 pt-0">
                        <ion-card class="m-0">
                          <ion-grid>
                            <ion-row>
                              <ion-col
                                *ngIf="paymentMethod"
                                class="p-0"
                                size="12"
                                size-lg="9"
                              >
                                <ion-grid class="p-0">
                                  <ion-row>
                                    <ion-col>
                                      <div
                                        style="
                                          border-radius: 8px;
                                          border: 1px solid lightgray;
                                          padding: 10px;
                                          position: relative;
                                        "
                                      >
                                        <table class="w-100">
                                          <tr>
                                            <td class="w-100">
                                              <div>
                                                Оплата
                                                <span>
                                                  <h2>
                                                    {{ paymentMethod.name }}
                                                  </h2>
                                                </span>
                                              </div>
                                              <div>
                                                <strong class="text-success">{{
                                                  getPaymentMethodName()
                                                }}</strong>
                                              </div>
                                              <div>
                                                {{ paymentMethod.instruction }}
                                              </div>
                                            </td>
                                            <td
                                              style="vertical-align: baseline"
                                            >
                                              <ion-button
                                                (click)="clearPaymentMethod()"
                                                fill="outline"
                                                color="dark"
                                              >
                                                <ion-icon
                                                  slot="start"
                                                  name="pencil-outline"
                                                ></ion-icon>
                                                змінити
                                              </ion-button>
                                            </td>
                                          </tr>
                                        </table>
                                      </div>
                                    </ion-col>
                                  </ion-row>
                                </ion-grid>
                              </ion-col>
                              <ion-col
                                *ngIf="paymentMethods && paymentMethods.length"
                                class="p-0"
                              >
                                <ion-grid class="p-0">
                                  <ion-row>
                                    <ion-col
                                      *ngFor="let method of paymentMethods"
                                    >
                                      <ion-button
                                        class="m-0"
                                        fill="outline"
                                        expand="block"
                                        size="large"
                                        (click)="selectPaymentMethod(method)"
                                      >
                                        {{ method.name }}
                                      </ion-button>
                                    </ion-col>
                                  </ion-row>
                                </ion-grid>
                              </ion-col>
                            </ion-row>
                          </ion-grid>
                        </ion-card>
                      </ion-col>
                    </ion-row>
                    <ion-row *ngIf="isPortretView">
                      <ion-col class="px-0">
                        <ion-card class="m-0">
                          <ng-container
                            [ngTemplateOutlet]="numpadTemp"
                          ></ng-container>
                        </ion-card>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col class="p-0">
                        <ion-card class="m-0">
                          <order-fiscal-switch
                            *ngIf="storeId"
                            #fiscalSwitch
                            [storeId]="storeId"
                          ></order-fiscal-switch>
                        </ion-card>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-button
                    (click)="close()"
                    fill="outline"
                    color="dark"
                    size="default"
                    style="height: 48px; font-size: 24px"
                  >
                    Відмінити оплату
                  </ion-button>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="isPortretView">
                <ion-col>
                  <ion-card class="m-0" style="padding: 6px">
                    <ion-item
                      lines="none"
                      class="ion-margin-top ion-margin-bottom"
                      *ngIf="displayPrintToggle"
                    >
                      <ion-icon name="print" slot="start"></ion-icon>
                      <ion-label>Друкувати чек</ion-label>
                      <ion-toggle
                        slot="end"
                        [checked]="printReceipt"
                        (ionChange)="togglePrintReceipt($event)"
                      ></ion-toggle>
                    </ion-item>
                    <ion-item
                      lines="none"
                      class="ion-margin-top ion-margin-bottom"
                      *ngIf="hasCahsDrawer"
                    >
                      <ion-button fill="outline" (click)="openCashDrawer()">
                        Відкрити грошову скриньку
                      </ion-button>
                    </ion-item>
                    <ion-item lines="none" *ngIf="paymentAmount">
                      <ion-label
                        color="medium"
                        class="ion-text-center m-0"
                        style="font-size: 3em"
                      >
                        <span>{{ currency }}</span>
                        <span>&nbsp;</span>
                        <span>{{ paymentAmount }}</span>
                      </ion-label>
                    </ion-item>
                    <ion-button
                      color="success"
                      [disabled]="loading"
                      (click)="pay()"
                      size="large"
                      style="font-size: 28px"
                      expand="block"
                    >
                      <span>{{ getPaymentName() }}</span>
                    </ion-button>
                  </ion-card>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </div>
      </td>
      <td style="padding: 5px 5px 5px 0" *ngIf="!isPortretView">
        <ion-card class="m-0 h-100">
          <table class="h-100">
            <tr>
              <td class="h-100" style="vertical-align: top">
                <ng-container [ngTemplateOutlet]="numpadTemp"></ng-container>
                <ion-item
                  lines="none"
                  class="ion-margin-top ion-margin-bottom"
                  *ngIf="displayPrintToggle"
                >
                  <ion-icon name="print" slot="start"></ion-icon>
                  <ion-label>Друкувати чек</ion-label>
                  <ion-toggle
                    slot="end"
                    [checked]="printReceipt"
                    (ionChange)="togglePrintReceipt($event)"
                  ></ion-toggle>
                </ion-item>
                <ion-item lines="none" *ngIf="hasCahsDrawer">
                  <ion-button
                    fill="outline"
                    color="dark"
                    (click)="openCashDrawer()"
                  >
                    Відкрити грошову скриньку
                  </ion-button>
                </ion-item>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="text-align: center; font-size: 3em"
                  *ngIf="paymentAmount"
                >
                  <span>{{ currency }}</span>
                  <span>&nbsp;</span>
                  <span>{{ paymentAmount }}</span>
                </div>
                <ion-button
                  color="success"
                  [disabled]="loading"
                  (click)="pay()"
                  size="large"
                  style="font-size: 28px"
                  expand="block"
                  class="m-0"
                >
                  <span>{{ getPaymentName() }}</span>
                </ion-button>
              </td>
            </tr>
          </table>
        </ion-card>
      </td>
    </tr>
  </table>
</ion-content>

<ng-template #numpadTemp>
  <app-numpad
    #nampad
    (change)="numpadInput($event)"
    [numpudConfig]="numpudConfig"
  ></app-numpad>
</ng-template>
<style>
  .money-field {
    border: 1px solid lightgrey;
    font-size: 36px;
    padding: 8px 10px;
    border-radius: 8px;
  }

  ::ng-deep .payment-modal {
    --width: 98%;
    --height: 97%;
  }

  ion-segment {
    --height: 70px !important;
    height: 70px !important;
    font-size: 20px !important;
  }

  @media (min-width: 820px) {
    .numpad-block {
      display: flex;
    }

    .payment-methods {
      display: initial;
    }

    .numpad-block-2 {
      display: none;
    }

    .payment-methods-2 {
      display: none;
    }
  }

  @media (max-width: 820px) {
    .bt-body {
      height: 98%;
      width: 97%;
    }
    .numpad-block {
      display: none;
    }

    .numpad-block-2 {
      display: initial;
    }

    .payment-methods {
      display: none;
    }
    .payment-methods-2 {
      display: flex;
    }
  }

  @media (min-width: 567px) {
    .numpad-block-3 {
      display: none;
    }
  }

  @media (max-width: 567px) {
    .numpad-block-3 {
      display: initial;
    }
  }

  ion-segment-button::part(indicator-background) {
    border: 1px solid #3880ff;
  }

  ion-segment-button.md::part(native) {
    color: #000;
  }

  .segment-button-checked.md::part(native) {
    color: #3880ff;
    /* border: 1px solid #3880ff; */
  }

  /* iOS styles */
  ion-segment-button.ios::part(native) {
    color: #000;
    /* border: 1px solid #3880ff; */
  }

  .segment-button-checked.ios::part(native) {
    /* color: #fff; */
    color: #3880ff;
  }

  .payment-btn {
    height: 3.2em;
  }

  .fake-input {
    border: 1px solid grey;
    padding: 2px 10px;
    border-radius: 8px;
    font-size: 26px;
    min-height: 40px;
    min-width: 30px;
  }

  .fake-input.focused {
    border-color: #3880ff !important;
  }

  .pay-input {
    border: 1px dashed grey;
    border-radius: 6px;
  }

  .pay-input h1 {
    min-height: 30px;
  }

  .pay-input.focused {
    border: 1px solid blue !important;
  }
</style>
